export enum RegStatusEnum {
  ManuallyEntered = 1,
  ReadingFailed,
  VerificationFailed,
  NoImages,
  SuccessfullyRead,
  SuccessfullyVerified,
  ManuallyUpdated,
}
